import api from './api';

export const getAlmox = query =>
	api.get('/stock/warehouse', { params: query });

export const getAll = query =>
	api.get('/stock/warehouse-sit', { params: query });